export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/company/status',
		name: 'NbuCompanyStatus',
		title: {
			single: 'NbuCompanyStatus',
			plural: 'NbuCompanyStatuses'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "N",
				"code": null,
				"name": "Нова",
				"caption": "Нова",
				"isBlocked": false
			},
			{
				"id": "A",
				"code": null,
				"name": "Включена до реєстру",
				"caption": "Включена до реєстру",
				"isBlocked": false
			},
			{
				"id": "C",
				"code": null,
				"name": "Виключена з реєстру",
				"caption": "Виключена з реєстру",
				"isBlocked": false
			}
		],
	},
}
